/**
 * Fixed pixel widths for the Network Discovery columns.
 *
 * Shared because the expanded row renders the grouped hosts as a sub-table that
 * has to line up with these columns (KIR-4838). The table runs
 * `tableLayout: 'fixed'`, so these are exact widths rather than hints, and two
 * independent copies of them would drift the moment one side was retuned.
 *
 * `lastSeen` is absent on purpose: it is a `timestamp` column, so its width
 * comes from the active Timestamp Format via `getTimestampColumnWidth`.
 *
 * Lives in its own module rather than in `columns.tsx` so that file keeps
 * exporting components only, which is what `react-refresh/only-export-components`
 * asks for — the same reason `timestampColumnWidth.ts` is split out.
 */
export const NETWORK_DOMAIN_COLUMN_WIDTHS = {
  agent: 160,
  domain: 300,
  processName: 180,
  status: 180,
  totalBytes: 120,
  hitCount: 100,
  uniqueUsers: 100,
  uniqueMachines: 110,
  actions: 180,
} as const;

/**
 * Width of the leading chevron cell the DataTable renders for an expandable
 * row (`w-10`). The sub-table reserves the same gutter so its first real
 * column starts where the Host column does.
 */
export const NETWORK_DOMAIN_EXPANDER_WIDTH = 40;

/**
 * Width of the synthetic row-selection checkbox column (`createSelectionColumn`
 * uses `size: 40`), which the DataTable prepends ahead of the real columns when
 * selection is enabled — as it is here.
 *
 * It is a SECOND leading gutter, after the chevron, and leaving it out is what
 * shifted every host cell one column to the left.
 */
export const NETWORK_DOMAIN_SELECT_WIDTH = 40;
